function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#D1DADD",
  fillOpacity: 0.4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6735 16.2502V33.7502C17.6735 34.4376 18.2359 35 18.9233 35H31.0766C31.7642 35 32.3268 34.4374 32.3268 33.7498V19.6037C32.3268 19.2199 32.1743 18.8518 31.903 18.5804L28.7464 15.4238C28.475 15.1525 28.1069 15 27.7231 15H18.9237C18.2361 15 17.6735 15.5626 17.6735 16.2502Z",
  fill: "#FB5806"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.0045 24.6485H28.9958C29.195 24.6485 29.3565 24.4871 29.3565 24.2879V23.4085C29.3565 23.2093 29.195 23.0479 28.9958 23.0479H21.0045C20.8054 23.0479 20.6439 23.2093 20.6439 23.4085V24.2879C20.6439 24.4871 20.8054 24.6485 21.0045 24.6485Z",
  fill: "#FFEBE6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.0043 27.1475H28.9956C29.1948 27.1475 29.3562 26.9861 29.3562 26.7869V25.9075C29.3562 25.7083 29.1948 25.5469 28.9956 25.5469H21.0043C20.8051 25.5469 20.6437 25.7083 20.6437 25.9075V26.7869C20.6437 26.9861 20.8051 27.1475 21.0043 27.1475Z",
  fill: "#FFEBE6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M21.0043 29.646H28.9956C29.1948 29.646 29.3562 29.4846 29.3562 29.2854V28.406C29.3562 28.2069 29.1948 28.0454 28.9956 28.0454H21.0043C20.8051 28.0454 20.6437 28.2069 20.6437 28.406V29.2854C20.6437 29.4846 20.8051 29.646 21.0043 29.646Z",
  fill: "#FFEBE6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9048 32.1446H24.9501C25.0943 32.1446 25.2112 32.0277 25.2112 31.8835V30.805C25.2112 30.6608 25.0943 30.5439 24.9501 30.5439H20.9048C20.7606 30.5439 20.6437 30.6608 20.6437 30.805V31.8835C20.6437 32.0277 20.7606 32.1446 20.9048 32.1446Z",
  fill: "#FFEBE6"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M28.746 15.4239C28.5601 15.238 28.3288 15.108 28.0782 15.0444V19.1198L32.3265 23.368V19.6037C32.3265 19.2199 32.174 18.8518 31.9026 18.5804L28.746 15.4239Z",
  fill: "#FB5806"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M32.2837 19.2523C32.2884 19.2724 32.2926 19.292 32.2965 19.3109H28.4672C28.196 19.3109 27.9762 19.0911 27.9762 18.8199V15.0225C28.0061 15.0278 28.0376 15.034 28.07 15.0412C28.3555 15.1043 28.6157 15.2511 28.8225 15.4578L31.8678 18.5031C32.0737 18.709 32.2183 18.9686 32.2837 19.2523Z",
  fill: "#FB5806"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M32.3265 32.5371V33.7496C32.3265 34.4372 31.764 34.9998 31.0764 34.9998H18.923C18.2356 34.9998 17.6732 34.4374 17.6732 33.75V32.5371H32.3265Z",
  fill: "#FB5806"
});

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.674a801c.svg";
export { ForwardRef as ReactComponent };